import { Flex, Skeleton } from "antd";
import LeftArrow from "../../../../assets/icons/LeftArrow";

export default function CertificateViewLoading() {
  return (
    <section className="bg-[#F5F5F5] py-10">
      <div className="container">
        <div className="flex items-center gap-2 text-theme-primary">
          <LeftArrow />
          <Skeleton.Input active size="small" style={{ width: 120 }} />
        </div>

        <div className="max-w-[750px] pt-10 pb-20 mx-auto">
          <div className="space-y-11">
            {/* Animated Icon Skeleton */}
            <Flex justify="center">
              <Skeleton.Avatar active size={112} shape="circle" />
            </Flex>

            {/* Title and Description Skeleton */}
            <div className="space-y-2">
              <Flex justify="center">
                <Skeleton.Input
                  active
                  size="large"
                  style={{ width: 300, height: 48 }}
                />
              </Flex>
              <Flex justify="center">
                <Skeleton.Input
                  active
                  size="default"
                  style={{ width: 350, height: 28 }}
                />
              </Flex>
              <Flex justify="center">
                <Skeleton.Input
                  active
                  size="default"
                  style={{ width: 400, height: 36 }}
                />
              </Flex>
            </div>

            <div className="space-y-6">
              {/* Score Cards Skeleton */}
              <div className="grid md:grid-cols-2 gap-6">
                <ScoreCardSkeleton />
                <ScoreCardSkeleton />
              </div>

              {/* Certificate Header Skeleton */}
              <Flex align="center" justify="space-between">
                <Skeleton.Input
                  active
                  size="large"
                  style={{ width: 150, height: 32 }}
                />

                <Flex align="center" gap={24}>
                  <Skeleton.Button
                    active
                    size="large"
                    shape="round"
                    style={{ width: 192, height: 40 }}
                  />
                  <Skeleton.Avatar active size={24} shape="circle" />
                </Flex>
              </Flex>

              {/* Certificate Image Skeleton */}
              <div className="rounded-xl border border-theme-zinc-200 overflow-hidden">
                <Skeleton.Image
                  active
                  className="!w-full"
                  style={{
                    height: 450,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const ScoreCardSkeleton = () => (
  <div className="p-6 bg-white rounded-xl border border-theme-zinc-200">
    <Flex justify="center" className="mb-2">
      <Skeleton.Input active size="large" style={{ width: 120, height: 72 }} />
    </Flex>
    <Flex justify="center">
      <Skeleton.Input active size="small" style={{ width: 150, height: 24 }} />
    </Flex>
  </div>
);
